import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useGetSalesChannelsLightList } from 'services/salesChannel';
import { IDistributionType, TEMPLATE_TYPE } from 'services/templates/types';
import { ISelectOption } from 'types/components/inputs/input.interface';
import { getSelectedDistributionSharesIds } from 'utils/dnd/dndUtilities';
import { IContractInputWrapperProps } from '../../wrapper/ContractInputWrapper';
import './ContractInputAgreementShares.scss';

interface IContractInputAgreementSharesProps
  extends Omit<IContractInputWrapperProps, 'name'> {
  id: string;
  distributionType: IDistributionType;
}

const ContractInputAgreementShares = ({
  id,
  distributionType,
  ...props
}: IContractInputAgreementSharesProps) => {
  const { setFieldValue, itemNameById, displayMode, values } =
    useFormikContractHelpers();

  const { t } = useTranslation();

  const salesChannels = useGetSalesChannelsLightList();

  const getSalesChannelOptions = () =>
    salesChannels.data?.map(channel => ({
      value: channel.id,
      label: channel.name,
      ...(getSelectedDistributionSharesIds(values, distributionType).includes(
        channel.id
      )
        ? { isDisabled: true }
        : {}),
    })) ?? [];

  const selectDefaultValue = (option: ISelectOption<string | number>) => {
    setFieldValue(
      `${itemNameById(id)}.content.distributionTemplateShares.name`,
      option.label
    );
    setFieldValue(
      `${itemNameById(id)}.content.distributionTemplateShares.id`,
      option.value
    );
  };



  const getShare = () => {

    const distributionPosition = () =>
      values.items[0].children.findIndex(item => item.type === distributionType);
  
    const distributionSharePosition = values.items[0].children
      .find(item => item.type === distributionType)
      ?.children.findIndex(item => item.id === id);
  
    const item = distributionSharePosition
      ? values.items[0].children[distributionPosition()].children[
          distributionSharePosition
        ]
      : undefined;

    const agreement =
      item?.type == TEMPLATE_TYPE.agreement ? item.content : undefined;
    const share = agreement?.distributionTemplateShares
      ? agreement?.distributionTemplateShares
      : undefined;

    return share ? { label: share.name, value: share.id } : undefined;
  };

  return (
    <Contract.Input.Wrapper {...props} id={id}>
      <FormInput.Select
        name={`${itemNameById(id)}.content.distributionTemplateShares.id`}
        placeholder={t('input.label.default-option')}
        className='contract-input-agreement contract-input-agreement-shares'
        onChange={selectDefaultValue}
        options={getSalesChannelOptions()}
        value={getShare()}
        displayMode={displayMode}
      />
      <FormInput.Number
        name={`${itemNameById(id)}.content.distributionTemplateShares.percent`}
        placeholder='0%'
        suffix='%'
        displayMode={displayMode}
      />
    </Contract.Input.Wrapper>
  );
};

export default ContractInputAgreementShares;
